import { Button, toast, Typography } from "@suraasa/placebo-ui"
import { useMutation, useQuery } from "@tanstack/react-query"
import api from "api"
import { queries } from "api/queries"
import Monitor from "assets/Fallback/monitor.svg"
import Fallback from "components/Fallback"
import { mapErrorsV2, saveBlobAsFile } from "utils/helpers"
import { useEnrollments } from "utils/hooks/useEnrollments"

import { useQualificationDetails } from ".."
import AcademicsGuide from "./AcademicsGuide"
import CourseWiseBreakDown from "./CourseWiseBreakDown"
import OverviewItem from "./OverviewItem"
import { getAdjustedScore, truncateScore } from "./scoreHelpers"
import Weightage from "./Weightage"

const GradeBook = () => {
  const { qualification, planner } = useQualificationDetails()
  const {
    pgctl: { isNewDeliveryMode },
  } = useEnrollments()

  const { data, isLoading, isError } = useQuery({
    enabled: Boolean(qualification.id),
    queryFn: () =>
      api.learningItems.retrieveGradeBookScore({
        urlParams: {
          qualificationId: qualification.id,
        },
      }),
    queryKey: queries.learningItems.retrieveGradeBookScore(qualification.id)
      .queryKey,
  })

  const { mutate: download, isPending } = useMutation({
    mutationFn: () =>
      api.learningItems.downloadGradeBookReport({
        urlParams: {
          learningItemId: planner.learningItemId,
        },
      }),
    onSuccess: res => {
      if (res.__data) {
        saveBlobAsFile({
          data: res.__data?.data,
          type: "application/pdf",
          name: `Gradebook.pdf`,
        })
        toast.success("File downloaded successfully!")
      }
    },
    onError: err => {
      mapErrorsV2(err)
    },
  })

  if (isError || isLoading) {
    return (
      <Fallback
        data={{
          title: "Something went wrong",
          description: "Please contact care@suraasa.com",
          image: Monitor,
        }}
        isLoading={isLoading || !data}
        hasError={isError}
        className="pt-4"
      />
    )
  }

  const canDownloadGradebook = data.items.every(
    item => item.score?.creditsEarned != null
  )

  return (
    <div className="flex flex-col">
      <div className="mb-2 flex items-center justify-between gap-2">
        <Typography variant="title3">Gradebook</Typography>
        {canDownloadGradebook && (
          <Button
            color="black"
            onClick={() => {
              download()
            }}
            loading={isPending}
            size="sm"
          >
            Download Gradebook
          </Button>
        )}
      </div>
      <div className="mb-3 flex flex-col items-center gap-2 sm:flex-row">
        <OverviewItem
          title="Overall GPA"
          value={
            data.score
              ? truncateScore(
                  getAdjustedScore(data.score.gpa, qualification.slug)
                ).toString()
              : null
          }
        />

        <OverviewItem
          title="Total Credits Earned"
          value={data.score?.creditsEarned?.toFixed(0) || null}
        />
      </div>
      {/* <HowGraphWorks className="mb-1" /> */}
      {/* <Graph className="mb-3" data={data.items} /> */}
      <CourseWiseBreakDown
        className="mb-3"
        items={data.items}
        slug={qualification.slug}
        isNewDeliveryMode={isNewDeliveryMode}
      />
      <AcademicsGuide className="mb-3" slug={qualification.slug} />
      <Weightage
        isNewDeliveryMode={isNewDeliveryMode}
        className="mb-3"
        slug={qualification.slug}
      />
    </div>
  )
}

export default GradeBook
